/* eslint-disable sort-keys */

const shadows = {
  card: '0 1px 2px rgb(15 20 25 / 4%), 0 1px 3px rgb(15 20 25 / 5%)',
  cardHover: '0 2px 4px rgb(15 20 25 / 4%), 0 12px 24px -4px rgb(15 20 25 / 10%)',
  focusRing: '0 0 0 2px rgb(47 92 129 / 75%)', // Single layer (usable with inset), >= 3:1 against white and gray surfaces
  popover: '0 4px 6px -2px rgb(15 20 25 / 5%), 0 16px 32px -8px rgb(15 20 25 / 16%)',
};

export default shadows;
